import { SelectPicture } from './SelectPicture';

export default SelectPicture;
